const Auth = {
  Login: '/login',
  Verify: '/verify',
  Signup: '/sign-up',
  ForgotPassword: '/forgot-password',
  ChangePassword: '/change-password',
};

const Dashboard = {
  Home: '/dashboard',
};

const ContactUs = {
  Home: '/contact-us',
};

const Profile = {
  Home: '/profile',
};

const AdditionalInfo = {
  Home: '/additional-info',
};

const NotFound = '/not-found';

const Course = {
  Form: '/forms/:id',
  Completed: '/completed',
  Resource: '/resources/:id',
};

export const Routes = {
  Auth,
  Course,
  Profile,
  NotFound,
  Home: '/',
  Dashboard,
  ContactUs,
  AdditionalInfo,
};
